function SocialsToolbar() {
    const instagramLink = "https://www.instagram.com/your-instagram-username/"; // Replace with actual link
    const instagramLogo = "https://sqlvas774pizbiy4km.blob.core.windows.net/liveenvironment/website/mila/elements/instagram icon.png";
    
    return (
        <div className="d-md-none z-1 position-fixed top-50 end-0 translate-middle-y">
            <a 
                href={instagramLink} 
                className='d-block mb-3'
                target="_blank" 
                rel="noopener noreferrer"
            >
                <img 
                    src={instagramLogo} 
                    className="social-icon" 
                    alt="Instagram" 
                    style={{ width: '40px', height: '40px', marginRight: '15px' }}
                />
            </a>
        </div>
    );
}

export default SocialsToolbar;